import {
  SET_COACHMARKS,
  COACHMARKS_API_REQUEST,
  COACHMARKS_API_SUCCESS,
  COACHMARKS_API_FAILURE,
} from '../actions/actionTypes';

const initialState = {
  loading: true,
  error: null,
  apply_coachmarks_complete: false,
  search_coachmarks_complete: false,
  saved_coachmarks_complete: false,
  scheduled_coachmarks_complete: false,
};

export default function coachmarks(state = initialState, action) {
  switch (action.type) {
    case SET_COACHMARKS: {
      const { data } = action.payload;
      return {
        ...state,
        ...data,
      };
    }
    case COACHMARKS_API_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case COACHMARKS_API_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case COACHMARKS_API_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
